module.exports = __webpack_public_path__ + "static/media/img22.99ffc7f2.JPG";